import * as Yup from "yup";
import type { DogCovered, DogEntryPage, DogQuote } from "@/api_client";
import { getErrorMessage } from "@/utils/errorMessage";
import { AgeValidator } from "@/validators/shared/ageValidators";
import { FinnishSSN } from "@/validators/shared/ssnValidator";

const validateSSN = (ssn: string) => {
  const finnishSSN = new FinnishSSN(ssn);
  return finnishSSN.validateSSN();
};

export type DogEntryFormObject = Pick<
  DogQuote,
  "dogCovered" | "policyHolderSsn"
>;

type DogEntryContent = DogEntryPage | undefined | null;

export const ResolveDogEntry = (
  content: DogEntryContent,
): Yup.ObjectSchema<DogEntryFormObject> =>
  Yup.object({
    policyHolderSsn: Yup.string()
      .required(
        getErrorMessage(
          content?.policyHolderSsn?.validationMessages?.value,
          "required",
        ),
      )
      .test(
        "valid-ssn",
        getErrorMessage(
          content?.policyHolderSsn?.validationMessages?.value,
          "valid-ssn",
        ),
        validateSSN,
      )
      .test(
        "is-18+",
        getErrorMessage(
          content?.policyHolderSsn?.validationMessages?.value,
          "is-18+",
        ),
        (ssn: string) => {
          const ageValidator = new AgeValidator(ssn);
          return ageValidator.isAtLeast18;
        },
      ),
    dogCovered: ResolveDogCovered(content),
  });

const ResolveDogCovered = (content: DogEntryContent) =>
  Yup.object<DogCovered>({
    dogBreed: Yup.string().required(
      getErrorMessage(
        content?.dogBreedQuestion?.validationMessages?.value,
        "required",
      ),
    ),
    dogName: Yup.string()
      .required(
        getErrorMessage(
          content?.dogNameQuestion?.validationMessages?.value,
          "required",
        ),
      )
      .max(
        30,
        getErrorMessage(
          content?.dogNameQuestion?.validationMessages?.value,
          "max-length",
        ),
      ),
  });
